import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueryParserService {

  parse(query: string, addWildCards: boolean, replaceFromString?: string, replaceWithString?: string) {
    let res = '';
    query = this.removeIllegalText(query);
    addWildCards = this.getAddWildCards(query, addWildCards);
    if (query) {
      const qTrim = query.trim();
      if (qTrim[0] === '"' && qTrim[qTrim.length - 1] === '"') {
        return qTrim.substring(1, qTrim.length - 1);
      }
      const hasQuotes = ['"', '\''].indexOf(qTrim.substring(qTrim.length - 1)) !== -1;
      res = this.splitAndCombineQuery(query, hasQuotes, addWildCards);
      if (replaceFromString && replaceWithString) {
        res = res.replaceAll(replaceFromString, replaceWithString)
      }
      res = res.trim();
      if (addWildCards && res.split(' ').length === 1 && !hasQuotes) {
        res = '*' + res;
      }
    } else if (addWildCards) {
      res = '*:*';
    }
    return res;
  }

  private getAddWildCards(query: string, addWildCards: boolean) {
    addWildCards = addWildCards !== undefined ? addWildCards : true;
    if (addWildCards && query?.includes('~') || query?.includes('^')) {
      addWildCards = false;
    }
    return addWildCards;
  }

  private splitAndCombineQuery(query: string, hasQuotes: boolean, addWildCards: boolean) {
    let res = '';
    let spc = '';
    const qSplit = this.cleanSplit(query);
    if (qSplit.length > 0) {
      for (let t = 0; t < qSplit.length - 1; t++) {
        res += spc + qSplit[t];
        spc = ' ';
      }
      const last = this.clean(qSplit[qSplit.length - 1]);
      res += spc + last;
      res = res.trim();
      if (!hasQuotes && addWildCards) {
        res += '*';
      }
    }
    return res;
  }

  private cleanSplit(query) {
    return query.split(/[\s\/()\-+:«»;,."]/g).filter(q => q !== '' && q !== ' ');
  }

  private removeIllegalText(query: string) {
    const requireStarts = ['^','AND', 'OR'];
    const requireEnds = ['^', 'OR', 'AND', 'NOT'];
    query = query ? query.trim() : '';
    if (!query) {
      return query;
    }
    for (const requireStart of requireStarts) {
      if (query.startsWith(requireStart)) {
        query = query.substring(requireStart.length).trim();
      }
    }
    for (const requireEnd of requireEnds) {
      if (query.endsWith(requireEnd)) {
        query = query.substring(0, query.length - requireEnd.length).trim();
      }
    }
    const indexOfHat = query.indexOf('^');
    if (indexOfHat !== -1) {
      const nextChar = query.charAt(indexOfHat + 1);
      // Must remove the ^ character if next character is not number, else search will fail
      const nextCharNumber = Number(nextChar);
      if (Number.isNaN(nextCharNumber)) {
        return query.replace('^', '');
      }
    }
    return query;
  }

  private clean(query: string) {
    return query.replace(/[\[\]{}]/g, '').trim();
  }

}
